import React from 'react'

export default ({ backgroundColor }) => (
  <svg viewBox="0 0 140 40" preserveAspectRatio="none">
    <polygon points="70,0 140,40 0,40" fill={backgroundColor} />
  </svg>
)
